<template>
  <div>
    <div class="page-breadcrumb">
      <div class="row">
        <div class="col-4 align-self-center">
          <h4 class="page-title">
            <i class="fas fa-seedling" /> Farm
          </h4>
          <div class="d-flex align-items-center">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <router-link :to="{name: 'dashboard'}">
                    Home
                  </router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  <strong>Farm</strong>
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <div class="col-8 align-self-center">
          <div class="d-flex no-block justify-content-end align-items-center" />
        </div>
      </div>
    </div>

    <router-view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'FarmLayout',
  computed: {
    ...mapGetters(['currentUser'])
  }
}
</script>

<style scoped>
</style>
